export default __webpack_public_path__ + "static/media/JeffScott.252021a8.svg";